import * as React from "react";
import { IInputFieldProps, HiddenFieldSchema } from "@generation/core";
import { withRegisterFieldHoc } from "../Hoc/withRegisterFieldHoc";
import { withValueSetHoc } from "../Hoc/withValueSetHoc";

const RegisteredHiddenField = withRegisterFieldHoc((props: IInputFieldProps<HiddenFieldSchema>) => {
  const { field, inputRef, ...otherProps } = props;

  return <input type="hidden" ref={inputRef} {...otherProps} />;
});

export const HiddenField = React.memo(
  withValueSetHoc((props: IInputFieldProps<HiddenFieldSchema>) => <RegisteredHiddenField {...props} />)
);
